import { createSlice } from "@reduxjs/toolkit";
import { campCities } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const citiesSlice = createSlice({
  name: "cities",
  initialState: data,
  reducers: {
    citiesSlice(state) {
      state.isLoading = false;
    },
    citiesSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    citiesSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    citiesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const citiesHandler = () => async (dispatch: any) => {
  try {
    dispatch(citiesAction.citiesSlice());
    const response: any = await campCities();
    dispatch(citiesAction.citiesSliceSuccess(response));
  } catch (e: any) {
    dispatch(citiesAction.citiesSliceFailure(e?.response?.data?.message));
    dispatch(citiesAction.citiesSliceReset());
  }
};
export default citiesSlice.reducer;
export const citiesAction = citiesSlice.actions;
